if (submitTag && userSignedUp && !localStorage.getItem(`sign_up${user}`)) {  
  brevoPush('user_sign_up_complete', {brand: brand});
  window.dataLayer.push({
    event: 'user_sign_up_complete',
    method: 'email'
  });
  localStorage.setItem(`sign_up${user}`, true);      
}

$(document).ready(function() {
  $('#genre').on('change',function() {
    var genreObj = {
      event: "event_filter_genre",
      filter_type: "genre",
      filter_value: $(this).val(),
      page_path: "/events",
      user_id: (user != '0') ? user : null,
      timestamp: new Date().toISOString()
    };
    if (genreObj.filter_value && submitTag) {
      brevoPush('event_filter_genre', {genre_selected: $(this).val()});
      window.dataLayer.push(genreObj);      
    }
  });
  $('#sort').on('change',function() {
    if (submitTag){
      var sort = $(this).val();
      var sortObj = {
        event: (sort == 'newest') ? "event_filter_sortby_recently_uploaded" : "event_filter_sortby_upcoming_first",
        filter_type: "sort",
        filter_value: (sort == 'newest') ? "recently_uploaded" : "upcoming_first",
        page_path: "/events",
        user_id: (user != '0') ? user : null,
        timestamp: new Date().toISOString()
      };
      brevoPush((sort == 'newest') ? "event_filter_sortby_recently_uploaded" : "event_filter_sortby_upcoming_first");
      window.dataLayer.push(sortObj);
     }
  });
  $('#hidesoldout').on('change',function() {
    if($(this).is(':checked') && submitTag){
      var soldOutObj = {
        event: "event_filter_hide_sold_out",
        filter_type: "availability",
        filter_value: "hide_sold_out",
        page_path: "/events",
        user_id: (user != '0') ? user : null,
        timestamp: new Date().toISOString()
      };
      brevoPush('event_filter_hide_sold_out');
      window.dataLayer.push(soldOutObj);
    }
  });
  var daterange = ''
  $('.litepicker').on('click',function() {
    if (submitTag){
        var currentDaterange = $('#daterange').val();
        if (currentDaterange && currentDaterange != daterange) {
          daterange = currentDaterange;
          var splitDates = daterange.split(' - ');
          var startDate = splitDates[0];
          var endDate = splitDates[1];
          var dataLayerDate = '';
          if (startDate == endDate) {
            var dateParts = startDate.split('/'); //format: 'DD/MM/YYYY'
            dataLayerDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
          } else {
            var startDateParts = startDate.split('/'); //format: 'DD/MM/YYYY'
            var endDateParts = endDate.split('/'); //format: 'DD/MM/YYYY'
            dataLayerDate = `${startDateParts[2]}-${startDateParts[1]}-${startDateParts[0]} to ${endDateParts[2]}-${endDateParts[1]}-${endDateParts[0]}`;
          }
          var dateRangeObj = {
            event: "event_filter_by_date",
            filter_type: "date",
            filter_value: dataLayerDate,  // or "2025-06-01 to 2025-06-07"
            page_path: "/events",
            user_id: (user != '0') ? user : null,
            timestamp: new Date().toISOString()
          };
        brevoPush('event_filter_by_date', {selected_date: dataLayerDate});
        window.dataLayer.push(dateRangeObj);
      }
    }
  });
  $('#location').on('change',function(){
    if (submitTag){
      var locationObj = {
        event: "event_filter_by_location",
        filter_type: "location",
        filter_value: $(this).val(),
        page_path: "/events",
        user_id: (user != '0') ? user : null,
        timestamp: new Date().toISOString()
      };
      brevoPush('event_filter_by_location', {typed_location: $(this).val()});
      window.dataLayer.push(locationObj);
    }
  });  
  var urlString = window.location.href;
  var url = new URL(urlString);
  var params = new URLSearchParams(url.search);
  
  var location = params.get('location')
  if (location && submitTag) {
    var locationViewObj = {
      event: 'user_views_all_events_near_them',
      event_id: 'view_near',
      user_postcode: location,
      page_path: '/',
      timestamp: new Date().toISOString()
    };
    brevoPush('user_views_all_events_near_them', {postcode: location});
    window.dataLayer.push(locationViewObj);    
  }

  var pageNumber = params.get('page');
  var event = params.get('event');
  if (submitTag && pageNumber && pageNumber > 3) {
    var furtherThan3Obj = {
      event: 'further_than_page_3',
      event_id: 'page_nav_' + new Date().getTime(),
      page_number: pageNumber,
      search_query: event,
      page_path: window.location.pathname + window.location.search,
      timestamp: new Date().toISOString()
    };
    brevoPush('further_than_page_3', {page_number: pageNumber});
    window.dataLayer.push(furtherThan3Obj);
  }

  $('.banner-update-preferences').on('click', function(){
    if (submitTag) {
      brevoPush('preferences_banner_click');
      window.dataLayer.push({
        event: 'preferences_banner_click',
        event_id: 'preferences_banner_click_' + new Date().getTime(),
        banner_name: 'Preferences Update Banner',
        page_path: '/',
        timestamp: new Date().toISOString()
      });
    }
  });

  $('.waitlist').on('click', function(){
    if (submitTag) {
      brevoPush('clicks_waitlist_event', {
        event_name: $(this).data('name'),
        event_id: 'waitlist_click_' + new Date().getTime()
      });
      window.dataLayer.push({
        event: 'clicks_waitlist_event',
        event_id: 'waitlist_click_' + new Date().getTime(),
        event_name: $(this).data('name'),
        page_path: window.location.pathname,
        timestamp: new Date().toISOString()
      });
    }
  });
});